// // src/components/CTA.tsx
// import React, { CSSProperties } from 'react';


// // Primary color defined as a constant
// const PRIMARY_COLOR = '#3498db';
// const PRIMARY_DARK = '#2980b9';

// const CTA: React.FC = () => {
//   return (
//     <section style={{ ...styles.ctaSection, backgroundColor: PRIMARY_COLOR }}>
//     <div style={styles.ctaContainer}>
//       <h2 style={styles.ctaHeading}>Ready to Simplify Your Logistics?</h2>
//       <p style={styles.ctaText}>
//         Join thousands of businesses using InstaShip for their shipping needs
//       </p>
//       <div style={styles.ctaButtons}>
//         <button style={styles.ctaPrimaryButton}>Get Started Today</button>
//         <button style={styles.ctaSecondaryButton}>Schedule a Demo</button>
//       </div>
//     </div>
//   </section>
//   );
// };



//   // Define a type for our styles object
//   type Styles = Record<string, CSSProperties>;

//   // Styles object with proper typing
//   const styles: Styles = {
  

  
//   // CTA styles
//   ctaSection: {
//     padding: '5rem 0',
//     backgroundColor: PRIMARY_COLOR,
//   },
//   ctaContainer: {
//     maxWidth: '800px',
//     margin: '0 auto',
//     padding: '0 1rem',
//     textAlign: 'center' as const, // Fix for textAlign type
//   },
//   ctaHeading: {
//     fontSize: '2.5rem',
//     fontWeight: 'bold',
//     color: '#fff',
//     marginBottom: '1.5rem',
//   },
//   ctaText: {
//     fontSize: '1.25rem',
//     color: '#dbeafe',
//     marginBottom: '2rem',
//     maxWidth: '600px',
//     marginLeft: 'auto',
//     marginRight: 'auto',
//   },
//   ctaButtons: {
//     display: 'flex',
//     justifyContent: 'center',
//     gap: '1rem',
//   },
//   ctaPrimaryButton: {
//     backgroundColor: '#fff',
//     color: PRIMARY_COLOR,
//     padding: '0.75rem 2rem',
//     borderRadius: '0.5rem',
//     fontWeight: '600',
//     border: 'none',
//     cursor: 'pointer',
//     fontSize: '1rem',
//   },
//   ctaSecondaryButton: {
//     backgroundColor: 'transparent',
//     color: '#fff',
//     padding: '0.75rem 2rem',
//     borderRadius: '0.5rem',
//     fontWeight: '600',
//     border: '2px solid #fff',
//     cursor: 'pointer',
//     fontSize: '1rem',
//   },
// }
// export default CTA;















// import React, { CSSProperties } from 'react';

// // Primary color defined as a constant
// const PRIMARY_COLOR = '#3498db';
// const PRIMARY_DARK = '#2980b9';

// const CTA: React.FC = () => {
//   return (
//     <section style={{ ...styles.ctaSection, backgroundColor: PRIMARY_COLOR }}>
//       <div style={styles.ctaContainer}>
//         <h2 style={styles.ctaHeading}>Ready to Simplify Your Logistics?</h2>
//         <p style={styles.ctaText}>
//           Join thousands of businesses using InstaShip for their shipping needs
//         </p>
//         <div style={styles.ctaButtons}>
//           <a
//             href="https://play.google.com/store/apps/details?id=your.package.name"
//             style={styles.storeBadge}
//             target="_blank"
//             rel="noopener noreferrer"
//           >
//             <img
//               src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
//               alt="Get it on Google Play"
//               style={styles.storeImage}
//             />
//           </a>
//           <a
//             href="https://apps.apple.com/app/your-app-id"
//             style={styles.storeBadge}
//             target="_blank"
//             rel="noopener noreferrer"
//           >
//             <img
//               src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
//               alt="Download on the App Store"
//               style={styles.storeImage}
//             />
//           </a>
//         </div>
//       </div>
//     </section>
//   );
// };

// // Define a type for our styles object
// type Styles = Record<string, CSSProperties>;

// // Styles object
// const styles: Styles = {
//   ctaSection: {
//     padding: '5rem 0',
//     backgroundColor: PRIMARY_COLOR,
//   },
//   ctaContainer: {
//     maxWidth: '800px',
//     margin: '0 auto',
//     padding: '0 1rem',
//     textAlign: 'center',
//   },
//   ctaHeading: {
//     fontSize: '2.5rem',
//     fontWeight: 'bold',
//     color: '#fff',
//     marginBottom: '1.5rem',
//   },
//   ctaText: {
//     fontSize: '1.25rem',
//     color: '#dbeafe',
//     marginBottom: '2rem',
//     maxWidth: '600px',
//     marginLeft: 'auto',
//     marginRight: 'auto',
//   },
//   ctaButtons: {
//     display: 'flex',
//     justifyContent: 'center',
//     flexWrap: 'wrap',
//     gap: '1rem',
//   },
//   storeBadge: {
//     display: 'inline-block',
//   },
//   storeImage: {
//     height: '60px',
//   },
// };

// export default CTA;















import React, { useEffect, useState } from 'react';
import mobileScreenshot from '../assets/platform/mobile.jpeg';

const GRADIENT_START = '#3498db';
const GRADIENT_END = '#2c81ba';

const CTA: React.FC = () => {
  const [hoveredBadge, setHoveredBadge] = useState<string | null>(null);

  const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth < 940);
  const [isNarrow, setIsNarrow] = useState<boolean>(window.innerWidth >= 940 && window.innerWidth < 1150);

  useEffect(() => {
    const handleResize = () => {
      const w = window.innerWidth;
      setIsMobile(w < 940);
      setIsNarrow(w >= 940 && w < 1150);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);


  



  

  return (
    <section style={{
      background: 'linear-gradient(135deg, #0F172A 0%, #1e3a5f 60%, #1a6fa8 100%)',
      padding: isMobile ? '48px 24px' : (isNarrow ? '60px 24px' : '80px 24px'),
      position: 'relative',
      overflow: 'hidden',
    }}>
      {/* Background glow */}
      <div style={{
        position: 'absolute', right: '-10%', top: '50%', transform: 'translateY(-50%)',
        width: 500, height: 500,
        background: 'radial-gradient(circle, rgba(52,152,219,0.2) 0%, transparent 70%)',
        pointerEvents: 'none',
      }} />

      <div style={{
        maxWidth: 1200, margin: '0 auto',
        display: 'flex',
        flexDirection: (isMobile || isNarrow) ? 'column' : 'row',
        alignItems: 'center',
        gap: (isMobile || isNarrow) ? 48 : 40,
        position: 'relative',
      }}>

        {/* ── LEFT: Daily Pickup CTA ── */}
        <div style={{ flex: (isMobile || isNarrow) ? '1 1 auto' : '0 0 auto', width: (isMobile || isNarrow) ? '100%' : 420 }}>
          {/* eyebrow */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 20 }}>
            <span style={{
              width: 8, height: 8, borderRadius: '50%',
              background: '#3498db',
              boxShadow: '0 0 10px rgba(52,152,219,0.9)',
              display: 'inline-block', flexShrink: 0,
            }} />
            <span style={{ fontSize: 13, fontWeight: 700, letterSpacing: '0.16em', color: '#3498db', textTransform: 'uppercase' }}>
              Daily Pickup Available
            </span>
          </div>

          {/* headline */}
          <h2 style={{
            fontSize: isMobile ? '1.9rem' : (isNarrow ? '2.2rem' : '2.6rem'),
            fontWeight: 800,
            color: '#fff',
            letterSpacing: '-0.03em',
            lineHeight: 1.18,
            marginBottom: 16,
          }}>
            Make Instaship<br />
            <span style={{ color: '#3498db' }}>Your Daily</span><br />
            Logistics Partner
          </h2>

          {/* sub-text */}
          <p style={{ fontSize: 16, color: '#7f96b0', lineHeight: 1.75, marginBottom: 40, maxWidth: 380 }}>
            Reliable daily pickups, real-time tracking, and dedicated support — so you can focus on growing your business, not calling transporters.
          </p>

          {/* call card */}
          <div style={{
            background: 'rgba(52,152,219,0.08)',
            border: '1px solid rgba(52,152,219,0.22)',
            borderRadius: 16,
            padding: '24px 28px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 20,
            flexWrap: 'wrap',
          }}>
            <div>
              <p style={{ fontSize: 14, fontWeight: 700, color: '#3498db', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: 6 }}>
                Need a daily pickup?
              </p>
              <p style={{ fontSize: 22, fontWeight: 800, color: '#fff', letterSpacing: '-0.01em', marginBottom: 2 }}>
                +91 83605 52876
              </p>
              <p style={{ fontSize: 13, color: '#7f96b0', margin: 0, fontWeight: 500 }}>
                Mon – Sat &nbsp;·&nbsp; 9 AM – 7 PM
              </p>
            </div>
            <a
              href="tel:+918360552876"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 10,
                background: 'linear-gradient(135deg, #3498db 0%, #1a6fa8 100%)',
                borderRadius: 12,
                padding: '13px 24px',
                textDecoration: 'none',
                fontSize: 14,
                fontWeight: 700,
                color: '#fff',
                letterSpacing: '0.02em',
                boxShadow: '0 6px 20px rgba(52,152,219,0.4)',
                transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                flexShrink: 0,
              }}
              onMouseEnter={e => {
                (e.currentTarget as HTMLAnchorElement).style.transform = 'translateY(-3px)';
                (e.currentTarget as HTMLAnchorElement).style.boxShadow = '0 12px 28px rgba(52,152,219,0.55)';
              }}
              onMouseLeave={e => {
                (e.currentTarget as HTMLAnchorElement).style.transform = 'none';
                (e.currentTarget as HTMLAnchorElement).style.boxShadow = '0 6px 20px rgba(52,152,219,0.4)';
              }}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 10.8a19.79 19.79 0 01-3.07-8.67A2 2 0 012 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 14.92z"/>
              </svg>
              Call Now
            </a>
          </div>
        </div>

        {/* ── DIVIDER ── */}
        {(!isMobile && !isNarrow) && (
          <div style={{
            width: 1, alignSelf: 'stretch',
            background: 'linear-gradient(to bottom, transparent, rgba(255,255,255,0.1) 30%, rgba(255,255,255,0.1) 70%, transparent)',
            flexShrink: 0,
          }} />
        )}

        {/* ── CENTER: Phone mockup (wide desktop) ── */}
        {(!isMobile && !isNarrow) && (
          <div style={{ flexShrink: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0 }}>
            {/* phone frame */}
            <div style={{
              position: 'relative',
              width: 220,
              borderRadius: 36,

              background: '#0a0a0a',
              border: '2px solid rgba(255,255,255,0.12)',
              boxShadow: '0 32px 64px rgba(0,0,0,0.6), 0 0 0 1px rgba(255,255,255,0.06), inset 0 0 0 1px rgba(0,0,0,0.8)',
              overflow: 'hidden',
              padding: '14px 10px',
            }}>
              {/* notch */}
              <div style={{
                position: 'absolute', top: 12, left: '50%', transform: 'translateX(-50%)',
                width: 72, height: 20,
                background: '#0a0a0a',
                borderRadius: 12,
                zIndex: 2,
              }} />
              {/* screen */}
              <div style={{ borderRadius: 26, overflow: 'hidden', position: 'relative' }}>
                <img
                  src={mobileScreenshot}
                  alt="Instaship App"
                  style={{ width: '100%', height: 'auto', display: 'block' }}
                />
              </div>
            </div>
            {/* label below phone */}
            <div style={{ marginTop: 20, textAlign: 'center' }}>
              <p style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.14em', color: '#3498db', textTransform: 'uppercase', margin: '0 0 4px 0' }}>Live App</p>
              <p style={{ fontSize: 13, color: '#4d6a82', margin: 0 }}>Instaship for Business</p>
            </div>
          </div>
        )}

        {/* ── CENTER: Phone mockup (mobile / narrow) ── */}
        {(isMobile || isNarrow) && (
          <>
            {/* Horizontal divider */}
            <div style={{ width: '100%', height: 1, background: 'linear-gradient(to right, transparent, rgba(255,255,255,0.12) 30%, rgba(255,255,255,0.12) 70%, transparent)' }} />

            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <div style={{
                position: 'relative',
                width: isNarrow ? 180 : 160,
                borderRadius: isNarrow ? 32 : 28,
                background: '#0a0a0a',
                border: '2px solid rgba(255,255,255,0.12)',
                boxShadow: '0 24px 48px rgba(0,0,0,0.6), 0 0 0 1px rgba(255,255,255,0.06)',
                overflow: 'hidden',
                padding: isNarrow ? '12px 9px' : '10px 8px',
              }}>
                <div style={{
                  position: 'absolute', top: 9, left: '50%', transform: 'translateX(-50%)',
                  width: isNarrow ? 62 : 54, height: 15, background: '#0a0a0a', borderRadius: 10, zIndex: 2,
                }} />
                <div style={{ borderRadius: isNarrow ? 22 : 20, overflow: 'hidden', position: 'relative' }}>
                  <img
                    src={mobileScreenshot}
                    alt="Instaship App"
                    style={{ width: '100%', height: 'auto', display: 'block' }}
                  />
                </div>
              </div>
            </div>
          </>
        )}

        {/* ── DIVIDER 2 ── */}
        {(!isMobile && !isNarrow) && (
          <div style={{
            width: 1, alignSelf: 'stretch',
            background: 'linear-gradient(to bottom, transparent, rgba(255,255,255,0.1) 30%, rgba(255,255,255,0.1) 70%, transparent)',
            flexShrink: 0,
          }} />
        )}

        {/* ── RIGHT: Download the App ── */}
        <div style={{ flex: 1, minWidth: 0 }}>
          <p style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.18em', color: '#7f96b0', textTransform: 'uppercase', marginBottom: 20 }}>
            Download the App
          </p>
          <h3 style={{
            fontSize: isMobile ? '1.5rem' : (isNarrow ? '1.75rem' : '2rem'),
            fontWeight: 800,
            color: '#fff',
            letterSpacing: '-0.02em',
            lineHeight: 1.25,
            marginBottom: 14,
          }}>
            Manage Everything<br />From One App
          </h3>
          <p style={{ fontSize: 15, color: '#7f96b0', lineHeight: 1.75, marginBottom: 40, maxWidth: 380 }}>
            Book shipments, track consignments, and manage your logistics — all from your pocket.
          </p>

          {/* store badges */}
          <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', marginBottom: 36 }}>
            <a
              href="https://play.google.com/store/apps/details?id=dev.expo.notificationsapptutlogistics"
              target="_blank"
              rel="noopener noreferrer"
              onMouseEnter={() => setHoveredBadge('google')}
              onMouseLeave={() => setHoveredBadge(null)}
              style={{
                display: 'inline-block',
                transition: 'transform 0.25s ease',
                transform: hoveredBadge === 'google' ? 'translateY(-4px)' : 'none',
              }}
            >
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                alt="Get it on Google Play"
                style={{ height: 'clamp(38px, 4vw, 48px)', width: 'auto', display: 'block' }}
              />
            </a>
            <a
              href="https://apps.apple.com/in/app/instaship/id6747907836"
              target="_blank"
              rel="noopener noreferrer"
              onMouseEnter={() => setHoveredBadge('apple')}
              onMouseLeave={() => setHoveredBadge(null)}
              style={{
                display: 'inline-block',
                transition: 'transform 0.25s ease',
                transform: hoveredBadge === 'apple' ? 'translateY(-4px)' : 'none',
              }}
            >
              <img
                src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
                alt="Download on the App Store"
                style={{ height: 'clamp(38px, 4vw, 48px)', width: 'auto', display: 'block' }}
              />
            </a>
          </div>

          {/* social proof row */}
          <div style={{ display: 'flex', gap: 32, flexWrap: 'wrap' }}>
            {[
              { value: '500+', label: 'Businesses' },
              { value: '1000+', label: 'Cities' },
              { value: '600+', label: 'Partners' },
            ].map(stat => (
              <div key={stat.label}>
                <p style={{ fontSize: 22, fontWeight: 800, color: '#fff', margin: '0 0 2px 0', letterSpacing: '-0.02em' }}>{stat.value}</p>
                <p style={{ fontSize: 12, fontWeight: 600, color: '#7f96b0', margin: 0, letterSpacing: '0.04em', textTransform: 'uppercase' }}>{stat.label}</p>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const _styles = {
  imageWrapper: {
    // width: '180px',
    // height: 'auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  











  ctaSection: {
    padding: '5rem 0',
    // backgroundColor: PRIMARY_COLOR,
    background: `linear-gradient(135deg, ${GRADIENT_START} 0%, ${GRADIENT_END} 100%)`,
  },
  ctaContainer: {
    maxWidth: '800px',
    margin: '0 auto',
    padding: '0 1rem',
    textAlign: 'center',
  },
  ctaHeading: {
    fontSize: '2.5rem',
    fontWeight: 'bold',
    color: '#fff',
    marginBottom: '1.5rem',
  },
  ctaText: {
    fontSize: '1.25rem',
    color: '#dbeafe',
    marginBottom: '2rem',
    maxWidth: '600px',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  ctaButtons: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: '1rem',
  },
  storeBadge: {
    display: 'inline-block',
    cursor: 'pointer',
  },
};

export default CTA;
